import { render, staticRenderFns } from "./account-purchase.vue?vue&type=template&id=70e2030f"
import script from "./account-purchase.vue?vue&type=script&lang=js"
export * from "./account-purchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports